export const GET_BANNER_REQUEST = "GET_BANNER_REQUEST";
export const GET_BANNER_SUCCESS = "GET_BANNER_SUCCESS";
export const GET_BANNER_ERROR = "GET_BANNER_ERROR";

export const GET_INTERNAL_BANNER_REQUEST = "GET_INTERNAL_BANNER_REQUEST";
export const GET_INTERNAL_BANNER_SUCCESS = "GET_INTERNAL_BANNER_SUCCESS";
export const GET_INTERNAL_BANNER_ERROR = "GET_INTERNAL_BANNER_ERROR";

export const GET_CATEGORY_REQUEST = "GET_CATEGORY_REQUEST";
export const GET_CATEGORY_SUCCESS = "GET_CATEGORY_SUCCESS";
export const GET_CATEGORY_ERROR = "GET_CATEGORY_ERROR";

export const GET_CATEGORY_DATA_REQUEST = "GET_CATEGORY_DATA_REQUEST";
export const GET_CATEGORY_DATA_SUCCESS = "GET_CATEGORY_DATA_SUCCESS";
export const GET_CATEGORY_DATA_ERROR = "GET_CATEGORY_DATA_ERROR";

export const GET_GREET_REQUEST = "GET_GREET_REQUEST";
export const GET_GREET_SUCCESS = "GET_GREET_SUCCESS";
export const GET_GREET_ERROR = "GET_GREET_ERROR";

export const GET_ALL_GREETINGS_REQUEST = "GET_ALL_GREETINGS_REQUEST";
export const GET_ALL_GREETINGS_SUCCESS = "GET_ALL_GREETINGS_SUCCESS";
export const GET_ALL_GREETINGS_ERROR = "GET_ALL_GREETINGS_ERROR";

//all send greetings
export const GET_SENT_GREETINGS_REQUEST = "GET_SENT_GREETINGS_REQUEST";
export const GET_SENT_GREETINGS_SUCCESS = "GET_SENT_GREETINGS_SUCCESS";
export const GET_SENT_GREETINGS_ERROR = "GET_SENT_GREETINGS_ERROR";

//all Receive greetings
export const GET_RECEIVE_GREETINGS_REQUEST = "GET_RECEIVE_GREETINGS_REQUEST";
export const GET_RECEIVE_GREETINGS_SUCCESS = "GET_RECEIVE_GREETINGS_SUCCESS";
export const GET_RECEIVE_GREETINGS_ERROR = "GET_RECEIVE_GREETINGS_ERROR";

export const GET_ALL_INVITATION_REQUEST = "GET_ALL_INVITATION_REQUEST";
export const GET_ALL_INVITATION_SUCCESS = "GET_ALL_INVITATION_SUCCESS";
export const GET_ALL_INVITATION_ERROR = "GET_ALL_INVITATION_ERROR";

export const GET_INVITATION_REQUEST = "GET_INVITATION_REQUEST";
export const GET_INVITATION_SUCCESS = "GET_INVITATION_SUCCESS";
export const GET_INVITATION_ERROR = "GET_INVITATION_ERROR";

export const GET_INSPIRATION_REQUEST = "GET_INSPIRATION_REQUEST";
export const GET_INSPIRATION_SUCCESS = "GET_INSPIRATION_SUCCESS";
export const GET_INSPIRATION_ERROR = "GET_INSPIRATION_ERROR";

export const GET_GROUP_CATEGORY_REQUEST = "GET_GROUP_CATEGORY_REQUEST";
export const GET_GROUP_CATEGORY_SUCCESS = "GET_GROUP_CATEGORY_SUCCESS";
export const GET_GROUP_CATEGORY_ERROR = "GET_GROUP_CATEGORY_ERROR";

export const GET_ALL_GROUP_REQUEST = "GET_ALL_GROUP_REQUEST";
export const GET_ALL_GROUP_SUCCESS = "GET_ALL_GROUP_SUCCESS";
export const GET_ALL_GROUP_ERROR = "GET_ALL_GROUP_ERROR";

export const GET_TRENDING_GREETING_REQUEST = "GET_TRENDING_GREETING_REQUEST";
export const GET_TRENDING_GREETING_SUCCESS = "GET_TRENDING_GREETING_SUCCESS";
export const GET_TRENDING_GREETING_ERROR = "GET_TRENDING_GREETING_ERROR";

export const GET_SENT_INVITATION_REQUEST = "GET_SENT_INVITATION_REQUEST";
export const GET_SENT_INVITATION_SUCCESS = "GET_SENT_INVITATION_SUCCESS";
export const GET_SENT_INVITATION_ERROR = "GET_SENT_INVITATION_ERROR";

export const GET_TRENDING_INVITATION_REQUEST =
  "GET_TRENDING_INVITATION_REQUEST";
export const GET_TRENDING_INVITATION_SUCCESS =
  "GET_TRENDING_INVITATION_SUCCESS";
export const GET_TRENDING_INVITATION_ERROR = "GET_TRENDING_INVITATION_ERROR";

export const GET_TRENDING_PRODUCT_REQUEST = "GET_TRENDING_PRODUCT_REQUEST";
export const GET_TRENDING_PRODUCT_SUCCESS = "GET_TRENDING_PRODUCT_SUCCESS";
export const GET_TRENDING_PRODUCT_ERROR = "GET_TRENDING_PRODUCT_ERROR";

export const GET_ALL_PRODUCTS_HOME_REQUEST = "GET_ALL_PRODUCTS_HOME_REQUEST";
export const GET_ALL_PRODUCTS_HOME_SUCCESS = "GET_ALL_PRODUCTS_HOME_SUCCESS";
export const GET_ALL_PRODUCTS_HOME_ERROR = "GET_ALL_PRODUCTS_HOME_ERROR";

export const GET_ALL_HOMEDECOR_REQUEST = "GET_ALL_HOMEDECOR_REQUEST";
export const GET_ALL_HOMEDECOR_SUCCESS = "GET_ALL_HOMEDECOR_SUCCESS";
export const GET_ALL_HOMEDECOR_ERROR = "GET_ALL_HOMEDECOR_ERROR";

export const GET_ALL_POTS_REQUEST = "GET_ALL_POTS_REQUEST";
export const GET_ALL_POTS_SUCCESS = "GET_ALL_POTS_SUCCESS";
export const GET_ALL_POTS_ERROR = "GET_ALL_POTS_ERROR";

export const GET_ALL_CAKES_REQUEST = "GET_ALL_CAKES_REQUEST";
export const GET_ALL_CAKES_SUCCESS = "GET_ALL_CAKES_SUCCESS";
export const GET_ALL_CAKES_ERROR = "GET_ALL_CAKES_ERROR";

export const GET_WISHFY_FRAMES_REQUEST = "GET_WISHFY_FRAMES_REQUEST";
export const GET_WISHFY_FRAMES_SUCCESS = "GET_WISHFY_FRAMES_SUCCESS";
export const GET_WISHFY_FRAMES_ERROR = "GET_WISHFY_FRAMES_ERROR";

export const GET_GIFT_DIARY_REQUEST = "GET_GIFT_DIARY_REQUEST";
export const GET_GIFT_DIARY_SUCCESS = "GET_GIFT_DIARY_SUCCESS";
export const GET_GIFT_DIARY_ERROR = "GET_GIFT_DIARY_ERROR";

//INTEREST GET
export const GET_INTEREST_REQUEST = "GET_INTEREST_REQUEST";
export const GET_INTEREST_SUCCESS = "GET_INTEREST_SUCCESS";
export const GET_INTEREST_ERROR = "GET_INTEREST_ERROR";
//my orders
export const GET_ORDERS_HISTORY_REQUEST = "GET_ORDERS_HISTORY_REQUEST";
export const GET_ORDERS_HISTORY_SUCCESS = "GET_ORDERS_HISTORY_SUCCESS";
export const GET_ORDERS_HISTORY_ERROR = "GET_ORDERS_HISTORY_ERROR";
//my orders
export const GET_MY_EVENTS_REQUEST = "GET_MY_EVENTS_REQUEST";
export const GET_MY_EVENTS_SUCCESS = "GET_MY_EVENTS_SUCCESS";
export const GET_MY_EVENTS_ERROR = "GET_MY_EVENTS_ERROR";

//  Banquet hall
export const GET_BANQUET_HALL_REQUEST = "GET_BANQUET_HALL_REQUEST";
export const GET_BANQUET_HALL_SUCCESS = "GET_BANQUET_HALL_SUCCESS";
export const GET_BANQUET_HALL_ERROR = "GET_BANQUET_HALL_ERROR";

// ADD REQUEST FROM HERE

export const ADD_GROUPS_REQUEST = "ADD_GROUPS_REQUEST";
export const ADD_GROUPS_SUCCESS = "ADD_GROUPS_SUCCESS";
export const ADD_GROUPS_ERROR = "ADD_GROUPS_ERROR";

//upload image for canvas
export const ADD_IMAGE_REQUEST = "ADD_IMAGE_REQUEST";
export const ADD_IMAGE_SUCCESS = "ADD_IMAGE_SUCCESS";
export const ADD_IMAGE_ERROR = "ADD_IMAGE_ERROR";

export const ADD_GIFT_DIARY_REQUEST = "ADD_GIFT_DIARY_REQUEST";
export const ADD_GIFT_DIARY_SUCCESS = "ADD_GIFT_DIARY_SUCCESS";
export const ADD_GIFT_DIARY_ERROR = "ADD_GIFT_DIARY_ERROR";

// send greetings
export const SEND_GREETINGS_REQUEST = "SEND_GREETINGS_REQUEST";
export const SEND_GREETINGS_SUCCESS = "SEND_GREETINGS_SUCCESS";
export const SEND_GREETINGS_ERROR = "SEND_GREETINGS_ERROR";

// Filter Inspiration
export const FETCH_INSPIRATION_BOARD_REQUEST =
  "FETCH_INSPIRATION_BOARD_REQUEST";
export const FETCH_INSPIRATION_BOARD_SUCCESS =
  "FETCH_INSPIRATION_BOARD_SUCCESS";
export const FETCH_INSPIRATION_BOARD_FAILURE =
  "FETCH_INSPIRATION_BOARD_FAILURE";
